/** @description 可放置的容器 */
import { useDrop } from 'react-dnd'
import { DropResult } from './box';

interface ContainerProps {
  id: string;
  onDrop: (item: DropResult) => void;
}

const Container: React.FC<ContainerProps> = (props) => {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: 'box',
    drop: props.onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }))

  const isActive = canDrop && isOver
  let backgroundColor = 'transparent'
  if (isActive) {
    backgroundColor = '#FFB4B4'
  } else if (canDrop) {
    backgroundColor = '#57C5B6'
  }

  return (
    <div ref={drop} style={{ backgroundColor, borderRadius: 4 }} data-testid={props.id}>
      { props.children }
    </div>
  )
}

export default Container;